import { useRadio } from "@chakra-ui/react";

export function RadioInput(props: any) {
  const { getInputProps } = useRadio(props);

  const input = getInputProps();

  return <input {...input} />;
}
